import ResourceDropdown from './ResourceDropdown';

export default ResourceDropdown;
